import React, { useEffect, useState } from "react";
import Proptypes from "prop-types";
import { BulletPoint, Button } from "../../Elements";
import { LearningPathWrapper } from "./style";
import { LearningPathPopup } from "@website-builder/ui/shared/elements";
import {
	BUTTON_INTERACTION,
	addToDataLayer,
} from "@website-builder/utilities-index";

const LearningPath = (props) => {
	const {
		header,
		text,
		bulletPoints,
		ctaText,
		subHeading,
		context,
		learningPathPopup,
	} = props;

	const apiBaseUrl = context.apiBaseUrl;
	const userApiEndpoint = `${apiBaseUrl}/user/`;
	const slug = context.slug;
	let curriculumLink = "";
	let location = "";
	let errorMessage = "";

	const [authorData, setAuthorData] = useState();
	const [curriculumPath, setCurriculumPath] = useState();
	const [popupCTA, setPopupCTA] = useState([]);

	if (typeof window != "undefined") {
		location = window.location.origin;
	}

	useEffect(() => {
		fetch(userApiEndpoint, {
			credentials: "include",
		})
			.then((res) => res.json())
			.then((response) => {
				const { code } = response;
				const redirectUrlWithPopup = `${location}/resources/learning-paths/${slug}/?lps=true`;
				if (code === 200) {
					curriculumLink = `${location}/learning-paths/${slug}/learn`;
					if (learningPathPopup) {
						setCurriculumPath(redirectUrlWithPopup);
						setPopupCTA([
							{
								buttonText: ctaText,
								event: BUTTON_INTERACTION.CTA_CLICK,
								link: {
									link: curriculumLink,
									type: "external",
									target: "_self",
								},
							},
						]);
					} else {
						setCurriculumPath(curriculumLink);
					}
				} else {
					const redirectUrl = `${location}/learning-paths/${slug}/learn/?referral=${location}`;
					curriculumLink = `${apiBaseUrl}/accounts/google/login/?process=login&next=${encodeURIComponent(
						learningPathPopup ? redirectUrlWithPopup : redirectUrl,
					)}`;
					setCurriculumPath(curriculumLink);
				}
			})
			.catch((err) => {
				errorMessage = "Something went wrong while fetching /user api";
				console.error(errorMessage);
			});
		const fetchAuthor = async () => {
			fetch(`${apiBaseUrl}/learning-paths/api/paths/${slug}`)
				.then((response) => response.json())
				.then((jsonData) => {
					setAuthorData(jsonData);
				})
				.catch((error) => {
					console.error(error);
				});
		};
		fetchAuthor();
	}, []);

	const redirectToCurriculum = () => {
		addToDataLayer({
			event: BUTTON_INTERACTION.CTA_CLICK,
			click_text: ctaText,
			redirect_to: curriculumPath,
			page_section: "Learning Path Banner",
		});
		window.location.href = curriculumPath;
	};

	return (
		<LearningPathWrapper>
			<div className="container">
				<div className="contentWrapper">
					<h6>{header}</h6>
					<div className="content">{text}</div>
					<div className="bulletContainer">
						{bulletPoints.map((text, index) => (
							<BulletPoint text={text} key={`${text}-${index}`} />
						))}
						<Button
							className="curriculumButton"
							onClick={() => redirectToCurriculum()}
						>
							{ctaText}
						</Button>
					</div>
				</div>
				<div className="imageWrapper">
					{authorData && (
						<div className="learners">
							<h6>Join {authorData?.total_users} Learners</h6>
							<ul className="learnersThumbnailContainer">
								{authorData?.users?.slice(0, 8).map((data, index) => (
									<li className="learnerThumbnail" key={index}>
										<img className="learnerImage" src={data?.picture_url} />
									</li>
								))}
							</ul>
						</div>
					)}
					{authorData && (
						<div className="authorContainer">
							<h6>{subHeading}</h6>
							<div className="avatar">
								<div className="avatarDetailsWrapper">
									<div className="avatarImage">
										<img src={authorData?.authors[0]?.userprofile?.picture} />
									</div>
									<div className="avatarDetails">
										<div className="name">
											{authorData?.authors[0]?.first_name}
										</div>
										<div className="title">
											{authorData?.authors[0]?.userprofile?.tagline}
										</div>
									</div>
								</div>
								<div className="avatarQuote">
									{authorData?.authors[0]?.userprofile?.profile}
								</div>
							</div>
						</div>
					)}
				</div>
			</div>
			{learningPathPopup && popupCTA.length ? (
				<LearningPathPopup
					context={context}
					{...learningPathPopup}
					CTA={popupCTA}
				/>
			) : null}
		</LearningPathWrapper>
	);
};

LearningPath.propTypes = {
	header: Proptypes.string,
	text: Proptypes.string,
	bulletPoints: Proptypes.array,
	ctaText: Proptypes.string,
	subHeading: Proptypes.string,
};

LearningPath.defaultProps = {
	header: "",
	text: "",
	bulletPoints: [],
	ctaText: "",
	subHeading: "",
};

export default LearningPath;
